import { render } from "./App.vue?vue&type=template&id=bf9d18ca"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=bf9d18ca&lang=scss"

import exportComponent from "D:\\projects\\APP\\vue3-ewshop\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__